import styled from 'styled-components';

export const Field = styled.span``;

export const FullLine = styled.div``;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;
